import React from "react";
import {useI18N} from "../../../../../my-puratos/hoc/withI18N";
import {BundleSummaryPrices} from "./BundleSummaryPrices";
import {BundleSummaryAddToCart} from "./BundleSummaryAddToCart";

export interface BundlePrices {
    UnitPrice: string;
    PromotionUnitPrice?: string;
    BundleId?: string;
}

export const BundleSummary: React.FC<BundlePrices> = ({UnitPrice, PromotionUnitPrice, BundleId}) => {
    const translate = useI18N();

    return (
            <div className={"pdp-bundle__summary"}>
            <span className={"pdp-bundle__summary-title"}>{translate("Total price")}</span>
                <BundleSummaryPrices UnitPrice={UnitPrice} PromotionUnitPrice={PromotionUnitPrice}/>
                <BundleSummaryAddToCart BundleId={BundleId}/>
            </div>
    )
}
